import './Footer.css';

function Footer() {
    return (
        <footer>
            <h3>Made by Lee, with <span>&#60;3</span></h3>
        </footer>
    )
}

export default Footer;